import { RestResourcesOptions } from '../type'

export const baseResources: RestResourcesOptions = {
  admins: null,
  'admins-count': { path: 'admins/count' },
  permissions: null,
  roles: { fullTextSearchFields: ['name'] },
  auth: null,
  products: null,
  'products-tire': { path: 'products/tire' },
  'products-shock': { path: 'products/shock' },
  'products-brake': { path: 'products/brake' },
  'products-lubricant': { path: 'products/lubricant' },
  'products-battery': { path: 'products/battery' },
  'products-other': { path: 'products/other' },
  'products-tire-count': { path: 'products/tire/count' },
  'products-shock-count': { path: 'products/shock/count' },
  'products-brake-count': { path: 'products/brake/count' },
  'products-lubricant-count': { path: 'products/lubricant/count' },
  'products-battery-count': { path: 'products/battery/count' },
  'products-other-count': { path: 'products/other/count' },


  'hero-banners': { path: 'website/homepage/hero-banners' },
  'portal-menus': { path: 'website/homepage/portal-menus' },
  'partner-icons': { path: 'website/homepage/partner-icons' },
  catalogues: { path: 'website/homepage/catalogues', fullTextSearchFields: ['title'] },
  'contact-us': { path: 'website/contact-us' },
  'job-opportunities': { path: 'website/job-opportunities' },
  promotions: { fullTextSearchFields: ['name'] },
  'promotions-banners': { path: 'promotions/banners' },
  services: { fullTextSearchFields: ['title'] },
  news: { fullTextSearchFields: ['title'] },
  blogs: { fullTextSearchFields: ['title'] },
  'cars-tire': { path: 'products/cars/tire' },
  'cars-brake': { path: 'products/cars/brake' },
  'cars-shock': { path: 'products/cars/shock' },
  'cars-battery': { path: 'products/cars/battery' },
  'brand-tire': { path: 'products/brands/tire' },
  'brand-brake': { path: 'products/brands/brake' },
  'brand-battery': { path: 'products/brands/battery' },
  'brand-shock': { path: 'products/brands/shock' },
  'brand-lubricant': { path: 'products/brands/lubricant' },
  'brand-other': { path: 'products/brands/other' },
  'products-banners': { path: 'website/products-services/banners' },
  'products-reviews': { path: 'products/reviews' },
  csr: { fullTextSearchFields: ['title'] },
  'news-blog-section': { path: 'website/homepage/news-blog' },
  'job-opportunity-banner': { path: 'website/job-opportunities/banner' },
  'mst-services-key': { path: 'services/mst/key' },
}